"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _DepositConfirmationModalComponent = _interopRequireDefault(require("./DepositConfirmationModalComponent"));
var _modalDecorator = _interopRequireDefault(require("../../hocs/modalDecorator"));
var _modalActions = require("../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openModal: function openModal() {
      return dispatch((0, _modalActions.openModal)(_modalActions.MODAL_TYPES.DEPOSIT_STATUS));
    }
  };
};
var container = (0, _reactRedux.connect)(null, mapDispatchToProps)(_DepositConfirmationModalComponent["default"]);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.DEPOSIT_STATUS
})(container);